
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import RadioGroupYesNo from '@/components/common/RadioGroupYesNo.vue'
import SelectConseiller from '@/components/common/SelectConseiller.vue'
import ProspectModel from '@/models/ProspectModel'
import convertDateDirective from '@/directives/convertDateDirective'
import convertAmountDirective from '@/directives/convertAmountDirective'
import {isCoprolibDate, isCoprolibNumber} from '@/helpers/validators'
import {FaRating} from 'vue-rate-it'
import ThumbsUp from 'vue-rate-it/glyphs/thumbs-up'
import {required, decimal} from 'vuelidate/lib/validators'

@Component({
  components: {
    BaseFormContainer,
    SelectRef,
    RadioGroupYesNo,
    SelectConseiller,
    FaRating
  },
  directives: {
    convertDateDirective,
    convertAmountDirective
  },
  validations: {
    form: {
      NOM: {
        required
      },
      DATE_OUVERTURE: {
        isCoprolibDate
      },
      DATE_CLOTURE_COMPTES: {
        isCoprolibDate
      },
      DATE_REPRISE_COMPTABLE: {
        isCoprolibDate
      },
      DATE_DERNIERE_ASSEMBLEE: {
        isCoprolibDate
      },
      DATE_PROCHAINE_REUNION_CS: {
        isCoprolibDate
      },
      DATE_PROCHAINE_ASSEMBLEE: {
        isCoprolibDate
      },
      HONORAIRES_SYNDIC_ACTUEL: {
        decimal
      },
      BUDGET_ACTUEL: {
        decimal
      }
    }
  }
})
export default class ProspectForm extends BaseForm {
  model = ProspectModel
  thumbsUp = null

  get labelDatePicker() {
    return 'Choisir une date'
  }

  get formatDatePicker() {
    return 'DD/MM/YYYY'
  }

  get formattedDatePicker() {
    return 'll'
  }

  get icon() {
    return this.thumbsUp
  }

  created() {
    this.thumbsUp = ThumbsUp
  }
}
